import Component from '../core/Component';

export default class VideoModal extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.id = this.$element.data("video");
        
        this.$element.on("click", ::this.open);
        $(document).on('videoModal:close', event => this.close())
        $(document).on('rewardModal:close', event => this.close())
    }

    open() {
        $("#"+this.id).addClass('is-active');

        setTimeout(() => {
            $("#"+this.id).addClass('is-animated')
        }, 0)
    }

    close() {
        $("#"+this.id).removeClass('is-animated')
        $("video").each(function () { this.pause() });
        setTimeout(() => {
            $("#"+this.id).removeClass('is-active')
        }, 500)
    }
}


// WEBPACK FOOTER //
// ./components/VideoModal.js